import './MultiCard.styles.css';

import { FC, useCallback } from 'react';

import Card from '../Card';
import { CardModel } from '../Card.types';
import { MultiCardProps } from './MultiCard.types';

const MultiCard: FC<MultiCardProps> = ({
  playerId,
  cards,
  cardsPosition,
  isTableCard,
  glowingCardsIndexes,
}) => {
  const calculateKey = useCallback(
    (card: CardModel, index: number) => {
      if (playerId) {
        return `${playerId}-card-${index}`;
      } else if (card?.suit && card?.cardNumber) {
        return `${card?.suit}-${card?.cardNumber}`;
      }
    },
    [playerId],
  );

  return (
    <div
      className="multicard-wrapper d-flex justify-content-center position-absolute z-2 "
      style={
        cardsPosition && { left: cardsPosition.cardX, top: cardsPosition.cardY }
      }
    >
      {cards.map((card, index) => (
        <Card
          key={calculateKey(card, index)}
          card={card}
          isTableCard={isTableCard}
          glow={glowingCardsIndexes?.includes(index)}
        />
      ))}
    </div>
  );
};

export default MultiCard;
